module.exports = __webpack_public_path__ + "media/stylesheets/images/main/star/star@3x-fe7f32584a422137f5cb525bccd78763.png";